module.exports = __webpack_public_path__ + "img/icon_mall_arr_next_on.f88e3756.svg";